/* eslint import/prefer-default-export: 0 */
import _ from 'lodash';

import * as t from './action_types';
import { initialState } from './reducer';

const listTypes = _.keyBy(_.keys(initialState));

/**
 * @param {Array} selectedIds
 */
export const changeSelectedTaskIds = selectedIds => ({
  type: t.CHANGE_SELECTED_TASK_IDS,
  payload: selectedIds,
  meta: listTypes.tasks,
});

/**
 * @param {Array} selectedIds
 */
export const changeSelectedPropertyIds = selectedIds => ({
  type: t.CHANGE_SELECTED_PROPERTY_IDS,
  payload: selectedIds,
  meta: listTypes.properties,
});

/**
 * @param {Array} selectedIds
 */
export const changeSelectedPersonIds = selectedIds => ({
  type: t.CHANGE_SELECTED_PERSON_IDS,
  payload: selectedIds,
  meta: listTypes.people,
});
